module.exports = __webpack_public_path__ + "img/party.db75a30b.png";